import { useEffect, useMemo, useState } from "react";
import * as F from "./filter.styles";
import TableTypeList from "../../components/products/list/TableTypeList";
import SingleProduct from "../../components/ecommerce/singleProduct/SingleProduct";

const FilteredList = (props) => {
  const {
    viewType,
    handleListViewType,
    dummyList,
    filteredList,
    purchaseDirect,
    handleCart,
    inCart,
    fixedViewType,
  } = props;
  const limit = 12;
  const max = 5;
  const [currentPage, setCurrentPage] = useState(1);

  const pages = useMemo(() => {
    return filteredList && Math.ceil(filteredList.length / limit);
  }, [filteredList, limit]);
  const startIndex = useMemo(() => {
    return (currentPage ? Number(currentPage) : 1) * limit - limit;
  }, [currentPage, limit]);
  const endIndex = useMemo(() => startIndex + limit, [startIndex, limit]);
  const start = useMemo(
    () => Math.floor(((currentPage || 1) - 1) / max) * max,
    [currentPage, max]
  );
  const end = useMemo(() => start + max, [start, max]);
  const pagination = useMemo(
    () => new Array(pages).fill().map((_, idx) => idx + 1),
    [pages]
  );
  const getPaginationGroup = useMemo(
    () => pagination.slice(start, end),
    [pagination, start, max]
  );
  const paginatedList = useMemo(
    () =>
      filteredList?.length > 0 ? filteredList.slice(startIndex, endIndex) : [],
    [filteredList, startIndex, endIndex]
  );

  // 페이지 네이션
  const next = () => {
    setCurrentPage(start + 6);
  };

  const prev = () => {
    setCurrentPage(start);
  };

  const handleActive = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [filteredList]);

  return (
    <>
      <F.ListWrapper>
        <F.ListSortWrapper>
          <div></div>
          <F.ListViewTypeWrapper>
            <div className="me-2">총 {filteredList?.length}개의 상품</div>
            {!fixedViewType && (
              <F.ListViewSelectBox listViewType={viewType ? viewType : "grid"}>
                <span
                  className={!viewType || viewType === "grid" ? "selected" : ""}
                  onClick={() => handleListViewType("grid")}
                >
                  <i className="fi-rs-grid" />
                </span>
                <span
                  className={viewType && viewType === "list" ? "selected" : ""}
                  onClick={() => handleListViewType("list")}
                >
                  <i className="fi-rs-list" />
                </span>
              </F.ListViewSelectBox>
            )}
          </F.ListViewTypeWrapper>
        </F.ListSortWrapper>
        <F.ProductsWrapper>
          {(!viewType || viewType === "grid") && (
            <F.ProductsGrid>
              {paginatedList &&
                paginatedList.map((item, i) => (
                  <div key={i}>
                    <SingleProduct
                      product={item}
                      dummyList={dummyList}
                      addCart={handleCart}
                      inCart={inCart}
                    />
                  </div>
                ))}
            </F.ProductsGrid>
          )}
          {viewType && viewType === "list" && (
            <>
              <TableTypeList
                productList={paginatedList}
                dummyList={dummyList}
                addCart={handleCart}
                inCart={inCart}
                viewFeature={false}
                purchaseDirect={purchaseDirect}
              />
            </>
          )}
        </F.ProductsWrapper>
        <div className="pagination-area mb-15">
          <nav aria-label="Page navigation">
            <ul className="pagination justify-content-start">
              {start == 0 || getPaginationGroup.length <= 0 ? null : (
                <li onClick={prev} className="page-item">
                  {currentPage == 1 ? null : (
                    <a className="page-link">
                      <i className="fi-rs-angle-double-small-left"></i>
                    </a>
                  )}
                </li>
              )}

              {getPaginationGroup.map((item, index) => {
                return (
                  <li
                    onClick={() => handleActive(item)}
                    key={index}
                    className={
                      currentPage == item ? "page-item active" : "page-item"
                    }
                  >
                    <a className="page-link">{item}</a>
                  </li>
                );
              })}
              {getPaginationGroup.length <= 0 ||
              pages <= 5 ||
              end > pages ? null : (
                <li onClick={next} className="page-item">
                  {currentPage >= pages ? null : (
                    <a className="page-link">
                      <i className="fi-rs-angle-double-small-right"></i>
                    </a>
                  )}
                </li>
              )}

              {getPaginationGroup.length <= 0 ? null : (
                <li className="d-none d-md-flex align-items-center ml-10">
                  총 {pages} 페이지
                </li>
              )}
            </ul>
          </nav>
        </div>
      </F.ListWrapper>
    </>
  );
};
export default FilteredList;
